import { Button, FCX, ID, TextInput, } from "@datassential/platform-ui-lib";
import Page from "@components/Page/Page";
import './MenuExamples.scss';
import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { currentCountrySelector } from "@selectors/countries.selector";
import { useCountryStates } from "@apiHooks/useCountryStates";
import StatesSelect from "@pages/MenuExamples/StatesSelect";
import cn from "classnames";
import MenuExamplesResultsTable from "@pages/MenuExamples/MenuExamplesResultsTable";
import { MENU_EXAMPLES_COUNTS } from "@constants/general";

const MenuExamples: FCX = () => {
    const countryCode = useSelector(currentCountrySelector);
    const counts = MENU_EXAMPLES_COUNTS[countryCode?.toUpperCase() ?? ''] ?? MENU_EXAMPLES_COUNTS.USA;

    const [query, setQuery] = useState('');
    const [submittedQuery, setSubmittedQuery] = useState('');
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [isChainsEnabled, setIsChainsEnabled] = useState(true);
    const [selectedStatesIds, setSelectedStatesIds] = useState<ID[]>([]);
    const { data: states } = useCountryStates(countryCode);

    const submitSearch = useCallback(
        () => {
            setIsSubmitted(query.trim() !== '');
            setSubmittedQuery(query);
        },
        [query]
    );

    useEffect(() => {
        setSelectedStatesIds([]);
    }, [states]);

    return (
        <Page isWrapped title="Menu Examples">
            <div className="MenuExamples">
                <div
                    className="MenuExamples__title"
                    data-testid="textMenuExamplesTitle"
                >
                    Menu Examples
                </div>
                <div className={cn("MenuExamples__content", !isSubmitted && 'expanded')}>
                    <div className="MenuExamples__row">
                        <div
                            className="MenuExamples__sub-title"
                            data-testid="textMenuExamplesHeaderTitle"
                        >
                            Browse over {counts.dishes} dishes from more than {counts.menus} unique menus
                        </div>
                    </div>
                    <div className="MenuExamples__row">
                        <TextInput
                            className="MenuExamples__search"
                            value={query}
                            setValue={setQuery}
                            onSubmit={submitSearch}
                            placeholder="Search anything..."
                            testId="inputMenuExamplesMainSearch"
                        />
                        <Button
                            onClick={submitSearch}
                            className="MenuExamples__search-button"
                            testId="buttonMenuExamplesMainSearchSubmit"
                        >
                            Search
                        </Button>
                    </div>
                    <StatesSelect
                        isChainsEnabled={isChainsEnabled}
                        setIsChainsEnabled={setIsChainsEnabled}
                        value={selectedStatesIds}
                        setValue={setSelectedStatesIds}
                        options={states}
                    />
                </div>
                {isSubmitted && (
                    <MenuExamplesResultsTable
                        query={submittedQuery}
                        selectedStatesIds={selectedStatesIds}
                        isChainsEnabled={isChainsEnabled}
                    />
                )}
            </div>
        </Page>
    );
};

export default MenuExamples;